// extracted by mini-css-extract-plugin
export default {"docx_node":"DocXContentNode_docx_node__DBl7X"};